import { getIABContentTaxonomy } from "@/api/stations.api"
import { notificationError } from "@/common/helpers/notifications.helper"

// The taxonomy is a large, account-independent reference list, so it is fetched once per session.
// Concurrent callers share the in-flight request instead of re-fetching it.
let pendingRequest = null

export const fetchIABGenres = async ({ commit, state }, { force = false } = {}) => {
  if (state.isLoaded && !force) {
    return state.genres
  }

  if (pendingRequest) {
    return pendingRequest
  }

  commit("setIsLoading", true)

  pendingRequest = getIABContentTaxonomy()
    .then((genres) => {
      commit("setGenres", genres)

      return genres
    })
    .catch((e) => {
      notificationError("Failed to load the IAB content taxonomy.")

      throw e
    })
    .finally(() => {
      pendingRequest = null
      commit("setIsLoading", false)
    })

  return pendingRequest
}
